var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GrupoLeyendaCheck',{attrs:{"titulo":"Áreas de estudio","checkboxType":"normal"},model:{value:(_vm.areas_expanded),callback:function ($$v) {_vm.areas_expanded=$$v},expression:"areas_expanded"}},[_c('span',{directives:[{name:"width-control",rawName:"v-width-control",value:('40%'),expression:"'40%'"}]}),_c('BotonMasInfo',{directives:[{name:"width-control",rawName:"v-width-control",value:('45%'),expression:"'45%'"}],on:{"click":_vm.masInfo}}),_c('DaiLeyendaMapa',{staticClass:"l-areas-estudio",attrs:{"para":[
      'areas_region_nororiental',
      'areas_subcuenca',
      'areas_zona_pelt',
      'areas_zona_federal_lago_texcoco',
      'areas_obra_principal_naim',
      
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }